import React, { useState } from 'react'
import './index.scss'
import RecentBookingList from './RecentBookingList'

const RecentBookingDetails = ({ recentBookings, isLoading }) => {
	return (
		
		<>
			<RecentBookingList
				recentBookings={recentBookings}
				isLoading={isLoading}
			/>
			</> 
		
	)
}

export default RecentBookingDetails
